// export default () => ({
// })

export default () => ({
    classifications: [],
    classificationsSelectable: [],
    classificationsPaginatedData: null,
    classification: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})